import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';

interface SplashProps {
  overrideLayoutPadding?: boolean;
}

const Splash = ({ overrideLayoutPadding = false }: SplashProps) => {
  const data = useStaticQuery<GatsbyTypes.SplashScreenQueryQuery>(graphql`
    query SplashScreenQuery {
      markdownRemark(frontmatter: { path: { eq: "splash" } }) {
        frontmatter {
          background {
            childImageSharp {
              ...HeroImage
            }
          }
          description
        }
      }
    }
  `);

  const splashScreenData = data.markdownRemark!.frontmatter!;

  const { background, description } = splashScreenData;

  const image = getImage(background as ImageDataLike);
  if (!image) return null;

  return (
    <GatsbyImage
      image={image}
      alt={description!}
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        ...(overrideLayoutPadding && { top: 0, left: 0 }),
      }}
    />
  );
};

export default Splash;
